const body = document.querySelector('body');
const mobileNav = document.querySelector('.js-mobile-nav');
const mobileNavToggle = document.querySelectorAll('.js-mobile-nav-toggle');

if (mobileNavToggle) {
    mobileNavToggle.forEach(button => {
        button.addEventListener('click', () => {
            body.classList.toggle('is-mobile-open');
            mobileNav.classList.toggle('is-active');
        });
    });
}

const mobileNavParents = document.querySelectorAll('.mobile-nav .menu-item-has-children');

if (mobileNavParents) {
    mobileNavParents.forEach(parent => {
        parent.addEventListener('click', () => {
            parent.classList.toggle('is-active');
        });
    });
}

